import {Box, Typography} from '@mui/material';
import React, {useState} from 'react';
import {useReviewHeaderContext} from '../header/ReviewHeader';
import ArrIconButton from '../../../common/arr-icon-button/ArrIconButton';
import {ReactComponent as DownloadIcon} from '../../../../assets/images/download-base-icon.svg';
import {ReactComponent as DeleteIcon} from '../../../../assets/images/delete.svg';

import {EditOutlined} from '@mui/icons-material';
import {t} from 'i18next';
import {getProtocolDownload} from '../../../../api/endpoints/aiReviewApi';
import {
  createPreciseTimestampedFilename,
  downloadBlob,
} from '../../../background-tasks/backgroundTasksUtils';
import ArrToastNotification from '../../../common/arr-toast-notification/ArrToastNotification';
import {ToastType} from '../../../../shared/constants';
import {downloadProtocolXlsx} from './utils';

interface IProtocolActionsHeader {
  setIsDeleteModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ProtocolActionsHeader = ({
  setIsDeleteModalOpen,
}: IProtocolActionsHeader) => {
  const [showToast, setShowToast] = useState(false);
  const {
    fileName,
    setShowEditProtocolIntelligence,
    isApproved,
    protocolDetails,
  } = useReviewHeaderContext();

  const handleEditProtocolClick = () => {
    if (isApproved) setShowEditProtocolIntelligence(true);
  };

  const onDownloadProtocolClicked = async () => {
    if (!protocolDetails?.protocolId) return;
    const {
      isSuccess = false,
      data: response,
      headers,
    } = await getProtocolDownload(protocolDetails?.protocolId);

    if (response instanceof Blob && isSuccess) {
      const contentType = headers['content-type'] || 'application/octet-stream';

      const fileName = createPreciseTimestampedFilename(
        `Protocol_${protocolDetails?.protocolId}`
      );

      const blob = new Blob([response], {type: contentType});
      const csvText = await blob.text();
      const rowsFromCsv = csvText
        .trim()
        .split('\n')
        .map((row) => row.split(','));
      downloadProtocolXlsx(rowsFromCsv, fileName);
    } else {
      setShowToast(true);
      console.error('download protocol failed');
    }
  };
  return (
    <>
      {showToast && (
        <ArrToastNotification
          message={'Error to download protocol report'}
          onClose={() => {
            setShowToast(false);
          }}
          status={[ToastType.Error]}
          data-testId={`${t(
            'ai.review.protocolIntelligence.protocolActions.downloadProtocol'
          )}-error-toast`}
        />
      )}
      <Box className="protocol-action-section">
        <Typography
          className="typo-text headline3_size text-headings"
          flex={1}
          tabIndex={0}
          data-testid="protocol-actions-header-file-name"
        >
          {fileName}
        </Typography>
        <Box className="actions">
          <ArrIconButton
            size="large"
            icon={<DownloadIcon />}
            onClick={onDownloadProtocolClicked}
            ariaLabel={t(
              'ai.review.protocolIntelligence.protocolActions.downloadProtocol'
            )}
            testId="download-protocol"
          />
          <ArrIconButton
            size="large"
            icon={<EditOutlined />}
            onClick={handleEditProtocolClick}
            ariaLabel={t(
              'ai.review.protocolIntelligence.protocolActions.editProtocol'
            )}
            testId="edit-protocol"
          />
          <ArrIconButton
            size="large"
            icon={<DeleteIcon />}
            onClick={() => setIsDeleteModalOpen(true)}
            ariaLabel={t(
              'ai.review.protocolIntelligence.protocolActions.deleteProtocol'
            )}
            className="delete-icon-btn"
            testId="delete-protocol"
          />
        </Box>
      </Box>
    </>
  );
};
export default ProtocolActionsHeader;
